import Address from "./models/address.js";
import Item from "./models/item.js";

export default class GoogleMapsHelper {
	static fields = ['addressComponents', 'types', 'formattedAddress']

	static bootstrap_api(){

		(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
			key: xkit_params.GOOGLE_API_KEY,
			v: "weekly",
			// Use the 'v' parameter to indicate the version to use (weekly, beta, alpha, etc.).
			// Add other bootstrap parameters as needed, using camel case.
		});


		/*(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
			key: gb24_params.GOOGLE_API_KEY,
			v: "weekly",
			// Use the 'v' parameter to indicate the version to use (weekly, beta, alpha, etc.).
			// Add other bootstrap parameters as needed, using camel case.
		});*/
	}

	static async init_map( $elem , args ) {
		const { Map } = await google.maps.importLibrary("maps");

		window.loaded_ga = true
		jQuery('body').trigger('google-maps-loaded' )

		let default_args = {
			zoom: 11,
			tilt:0,
			mapTypeControl: false,
			// mapTypeId: "satellite",
			mapId: "xkit",
			streetViewControl: false,
			rotateControl: false,
		}

		let elem = $elem[0]
		let map_args = Object.assign( {}, default_args, args )
		let map = new Map( elem, map_args );

		// const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
		// let marker = new AdvancedMarkerElement({ map } )

		// const {Place} = await google.maps.importLibrary("places");

		if ( elem.dataset.marker && elem.dataset.marker != 'null' ) {
			let address = JSON.parse( elem.dataset.marker )
			if ( address.uid ) {
				address.data.geometry = {location: new google.maps.LatLng( address.lat, address.lng )}
				await this.setMarker( map, address )
			}
		}

		return map
	}
	static async setMarker( map, address ) {
		const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
		let marker = new AdvancedMarkerElement({ map } )

		if ( ! address.data || ! address.data.location ) {
			marker.setMap(null)
			return
		}

		// marker = new google.maps.Marker({
		// 	map,
		// 	// icon: image,
		// 	title: address.formatted_address,
		// 	position: address.data.geometry.location,
		// })

		marker.setMap(map)
		map.setCenter( address.data.location );
		// this.map.setZoom(19)
		// marker.setPosition(address.data.geometry.location)
		// marker.setTitle(address.formatted_address)
		marker.position = address.data.location
		marker.title = address.formatted_address
	}

	static map_server_address( place ) {
		let address = new Address();
		if (place == null) {
			return address
		}
		const country = this.getPlaceCountry(place)
		const city = this.getPlaceCity(place)
		let county = this.getPlaceState(place)
		let server_address = this.getPlaceAddress(place)
		// There are cases in which we have a city, but no county,
		// like for Budapest which is both city and county.
		if (city.shortText && !county.shortText) {
			county = city
		}

		const country_longText = country.longText || null
		const county_longText = county.longText || null
		const city_longText = city.longText || null // 'All'

		address.uuid = null
		address.country = new Item(null, country_longText, country.shortText)
		address.county = new Item(null, county_longText, county.shortText)
		address.city = new Item(null, city_longText, city.shortText)
		address.address = server_address
		address.formatted_address = place.formattedAddress
		address.uid = place.id
		address.lat = place.location.lat()
		address.lng = place.location.lng()
		address.data = place
		return address
	}
	static getPlaceAddressComponentOfType(place, type) {
		var component = null;
		if (place instanceof Object && place.addressComponents instanceof Array) {
			for (var i = 0; i < place.addressComponents.length; i++) {
				if (place.addressComponents[i].types instanceof Array && jQuery.inArray(type, place.addressComponents[i].types) >= 0) {
					component = place.addressComponents[i];
					break
				}
			}
		}
		return component
	}
	static getPlaceAddress(place) {
		var address = null;
		if (null !== place) {
			var address_route = '', address_street = ''
			var component = this.getPlaceAddressComponentOfType(place, "route");
			component instanceof Object && (address_route = component.longText)

			component = this.getPlaceAddressComponentOfType(place, "street_number");
			component instanceof Object && (address_street = component.longText)
			address = address_route + ' ' + address_street
		}
		return address
	}
	static getPlaceAddress1(place) {
		var address_1 = null;
		return null !== place && place instanceof Object && (address_1 = place.name),
			address_1
	}
	static getPlaceCity(place) {
		var city = { shortText: '', longText: ''};
		if (null !== place) {
			const country = this.getPlaceCountry( place )

			var component = null;

			// Monaco
			if ('MC' == country.shortText) {
				component = this.getPlaceAddressComponentOfType(place, "sublocality");
			}
			else {
				component = this.getPlaceAddressComponentOfType(place, "locality");

				if (!component) {
					if ('England' == country.shortText) { // || 'SE' == country.shortText
						component = this.getPlaceAddressComponentOfType(place, "postal_town")
					}

				}

				if (!component) {
					component = this.getPlaceAddressComponentOfType(place, "sublocality");
				}
			}

			if ( component instanceof Object ) {
				city = component
			}
		}
		return city
	}
	static getPlaceState(place) {
		var state = { shortText: '', longText: ''};
		if (null !== place) {

			// get the correct division. see https://developers.google.com/maps/documentation/javascript/geocoding#GeocodingAddressTypes
			//for ( let i = 5; i >= 1; i--) {
			const country = this.getPlaceCountry( place )

			var component;
			if ( [ 'MC' ].includes( country.shortText ) ) {
				component = this.getPlaceAddressComponentOfType(place, "locality" );
			} else {
				// Bosnia and Herzegovina.
				if ( [ 'England', 'BA' ].includes( country.shortText ) ) {
					component = this.getPlaceAddressComponentOfType(place, "administrative_area_level_2");
				} else {
					component = this.getPlaceAddressComponentOfType(place, "administrative_area_level_1");
				}

			}

			component instanceof Object && (state = component)
		}
		return state
	}
	static getPlaceCountry(place) {
		var country = { shortText: '', longText: ''};
		if (null !== place) {

			var component;
			component = this.getPlaceAddressComponentOfType(place, "country");

			// For UK we set as country admin level 1, like England/Scotland, if available.
			if ( [ 'GB' ].includes( component.shortText ) ) {
				let adm_lvl_1 = this.getPlaceAddressComponentOfType(place, "administrative_area_level_1");
				if ( adm_lvl_1 ) {
					component = adm_lvl_1
				}
			}
			component instanceof Object && (country = component)
		}
		return country
	}
	static getPlaceZip(place) {
		var zip = null;
		if (null !== place) {
			var component = this.getPlaceAddressComponentOfType(place, "postal_code");
			component instanceof Object && (zip = component.longText)
		}
		return zip
	}


	static get geocoder_old(){
		if( ! this._geocoder ) {
			this._geocoder = new google.maps.Geocoder();
		}
		return this._geocoder
	}
	static async getGeocoderService(){
		if( ! this._geocoder ) {
			this._geocoder = await google.maps.importLibrary("geocoding");
		}
		return this._geocoder
	}
	static async getPlaceByLatLong( { lat, lng }, cb ){
		const { Geocoder } = await GoogleMapsHelper.getGeocoderService()
		let geocoder = new Geocoder()
		const res = await geocoder.geocode( { 'location': new google.maps.LatLng(lat, lng) })
		// componentRestrictions: {
		// 	country: "US",
		// 		locality: "chicago",
		// },

		if (res.results.length === 0) {
			alert('Geocode was not successful for the following reason: ');
			console.log(res)
			return null;
		}

		const { Place } = await GoogleMapsHelper.getPlacesService()

		return new Place( { id: res.results[0].place_id })

		/*const location = res.results[0].geometry.location;
		const place = {
			lat: location.lat(),
			lng: location.lng(),
			formatted_address: res.results[0].formatted_address,
		};
		return place;*/
	}

	static async getPlacesService(){
		if( ! this._place ) {
			this._place = await google.maps.importLibrary("places");
		}
		return this._place
	}

	static get placeServiceold(){
		if( ! this._placeervice ) {
			var div = window.document.getElementById('gac-service')
			if( ! div ) {
				div = window.document.createElement('div')
				div.setAttribute('id', 'gac-service')
			}
			this._placeervice = new google.maps.places.PlacesService(div);
		}
		return this._placeervice
	}
	static async getPlaceOld(placeId, cb){
		const { Place } = GoogleMapsHelper.getPlacesService()
		let place = new Place(placeId)
		await place.fetchFields({ fields: this.fields });
		return place
		/*
		place.getDetails(
			{
				placeId: placeId,
				fields: this.fields
			}, cb
		);*/
	}

	static get_current_location( success_cb, error_cb ) {
		let self = this
		// Try HTML5 geolocation.
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(function(position) {
				var pos = {
					lat: position.coords.latitude,
					lng: position.coords.longitude
				};

				self.getPlaceByLatLong( pos, function( place ){
					success_cb( place )
				} )

			}, function() {
				error_cb()
				//handleLocationError(true, infoWindow, map.getCenter());
			})
		} else {
			// Browser doesn't support Geolocation
			error_cb()
			//handleLocationError(false, infoWindow, map.getCenter());
		}
	}
}